<template>
    <div class="template-item" :class="{ 'bigimg': type === 'category' }" @click="useTemplate">
        <img :src="template.previewUrl" alt="" class="template-image">
    </div>
</template>

<script lang="ts" setup>
import { ref, reactive } from 'vue';
import { useSdkStore } from '@/stores/sdk'

const sdkStore = useSdkStore()

const desginsdk = sdkStore.getSdk()
const props = defineProps<{
    template?: any,
    type?: string
}>()
import { ElMessageBox } from 'element-plus'
import { useUserStore } from '@/stores/user'
const userStore = useUserStore()
const islogin = userStore.isLoggedIn

const useTemplate = async (item) => {
    if (!islogin) {
        try {
            await ElMessageBox.confirm(
                '您还未登录，请先登录后再使用模板功能',
                '登录提示',
                {
                    confirmButtonText: '去登录',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: true
                }
            )
                // 用户点击"去登录"，跳转到登录页面
                ; (window as any).openGlobalLogin?.()
        } catch {
            // 用户点击"取消"或关闭对话框，不做任何操作
            return
        }
        return
    };
    console.log('props.template.value---', props.template)
    let templates = props.template.fileUrl.split(',')
    for (let i = 0; i < templates.length; i++) {
        await useMaterialTemplate(templates[i])
    }
}
const useMaterialTemplate = async (item) => {
    const fileSuffix = item.split('.').pop()
    if (['jpg', 'jpeg', 'png', 'webp'].includes(fileSuffix)) {
        desginsdk.addElement.createImageElement(item)
        return
    }
    desginsdk.designOpt.requireFile(item)

}




</script>
<style lang="scss" scoped>
.template-item {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
    overflow: hidden;
    position: relative;
    aspect-ratio: 1;
    width: 100%;
    height: 80px;
}

.template-item:hover {
    .template-image {
        transform: scale(1.1);
        transition: all 0.3s ease;
    }
}

.template-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    transition: all 0.3s ease;
}

.bigimg {
    width: 100%;
    height: 250px;
}
</style>
